import { RandomUtils } from '@colonist/utils';
import { UIUtilsEjsVariables } from './UIUtilsEjsVariables.ts';
import { StorageWrapper } from './StorageWrapper.ts';
import { ClientUserState } from './ClientUserState.ts';
import { RankedConstants } from '../../../shared/GameEnums.ts';
import { getReplayUrlSlug } from './ui_replay/ReplayUrlUtilities.ts';
(function(UserSessionUtils) {
    function canShowLoginPopup() {
        var _ClientUserState_userState, _ClientUserState_userState1;
        const isUserWatchingReplayShareableLink = getReplayUrlSlug(window.location.href) !== undefined;
        if (isUserWatchingReplayShareableLink) return false;
        if (UIUtilsEjsVariables.isUserOnDiscord) return false;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn) return false;
        if ((_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.hasZeroCompletedGames()) return false;
        if (RandomUtils.randomIntBetween(0, 1) === 0) return false;
        // if(ClientUserState.userState.karmaCompletedGameCount < 1) return false
        return true;
    }
    UserSessionUtils.canShowLoginPopup = canShowLoginPopup;
    function canShowDiscordKeepPlayingOnWebPopup() {
        if (!UIUtilsEjsVariables.isUserOnDiscord) return false;
        if (StorageWrapper.getDiscordKeepPlayingOnWebPopupShown() == true) return false;
        const languagesEligibleForPopup = [
            'ru'
        ];
        return languagesEligibleForPopup.includes(UIUtilsEjsVariables.language);
    }
    UserSessionUtils.canShowDiscordKeepPlayingOnWebPopup = canShowDiscordKeepPlayingOnWebPopup;
    function canShowSubscriptionPopup() {
        var _ClientUserState_userState, _ClientUserState_userState1;
        if (UIUtilsEjsVariables.isUserOnDiscordMobile) return false;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasMembership()) return false;
        if ((_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.hasZeroCompletedGames()) return false;
        return true;
    }
    UserSessionUtils.canShowSubscriptionPopup = canShowSubscriptionPopup;
    function canShowRushIncentivePopup() {
        var _ClientUserState_userState, _ClientUserState_userState1;
        if (UIUtilsEjsVariables.isUserOnDiscordMobile) return false;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasMembership()) return false;
        if ((_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.hasZeroCompletedGames()) return false;
        return StorageWrapper.getRushGamesPlayed() == 0;
    }
    UserSessionUtils.canShowRushIncentivePopup = canShowRushIncentivePopup;
    function shouldShowChangeUsernamePopup(matchmakingMatchType) {
        var _ClientUserState_userState;
        if (UIUtilsEjsVariables.isUserOnDiscord == false) return false;
        var _ClientUserState_userState_usernameChangeAttemptsLeft;
        if (((_ClientUserState_userState_usernameChangeAttemptsLeft = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.usernameChangeAttemptsLeft) !== null && _ClientUserState_userState_usernameChangeAttemptsLeft !== void 0 ? _ClientUserState_userState_usernameChangeAttemptsLeft : 0) < 1) return false;
        if (StorageWrapper.getDiscordOnlineUsernamePopupShown() == true) return false;
        if (matchmakingMatchType == undefined) return false;
        return true;
    }
    UserSessionUtils.shouldShowChangeUsernamePopup = shouldShowChangeUsernamePopup;
    function userEligibleForRanked() {
        var _ClientUserState_userState;
        var _ClientUserState_userState_totalCompletedGameCount;
        return ((_ClientUserState_userState_totalCompletedGameCount = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.totalCompletedGameCount) !== null && _ClientUserState_userState_totalCompletedGameCount !== void 0 ? _ClientUserState_userState_totalCompletedGameCount : 0) >= RankedConstants.NumberOfGamesToUnlockRanked;
    }
    UserSessionUtils.userEligibleForRanked = userEligibleForRanked;
    function gamesLeftToUnlockRanked() {
        var _ClientUserState_userState;
        var _ClientUserState_userState_totalCompletedGameCount;
        return RankedConstants.NumberOfGamesToUnlockRanked - ((_ClientUserState_userState_totalCompletedGameCount = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.totalCompletedGameCount) !== null && _ClientUserState_userState_totalCompletedGameCount !== void 0 ? _ClientUserState_userState_totalCompletedGameCount : 0);
    }
    UserSessionUtils.gamesLeftToUnlockRanked = gamesLeftToUnlockRanked;
    function shouldShowLobbyAds() {
        var _ClientUserState_userState;
        var _ClientUserState_userState_totalCompletedGameCount;
        return ((_ClientUserState_userState_totalCompletedGameCount = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.totalCompletedGameCount) !== null && _ClientUserState_userState_totalCompletedGameCount !== void 0 ? _ClientUserState_userState_totalCompletedGameCount : 0) >= RankedConstants.NumberOfGamesToUnlockRanked;
    }
    UserSessionUtils.shouldShowLobbyAds = shouldShowLobbyAds;
})(UserSessionUtils || (UserSessionUtils = {}));
export var UserSessionUtils;
